import Mn from 'backbone.marionette';
import DialogService from 'base/dialog_service';

import ContactView from 'base/views/contacts';

import JoinosComposeView from 'messaging/views/joinos';
import SmsComposeView from 'messaging/views/sms';


/** Send a Joinos message to a list of contacts.
 *
 */
const MessageSendingView = Mn.LayoutView.extend({
  template: require('messaging/templates/processing.html'),

  ui: {
    close: '.btn-close'
  },

  events: {
    'click @ui.close': 'close'
  },

  modelEvents: {
    sync: 'doneProcessing'
  },

  close() {
    this.modal.close();
  },

  initialize() {
    this.processing = true;
  },

  templateHelpers() {
    return {
      processing: this.processing
    };
  },

  doneProcessing() {
    this.processing = false;
    this.render();
  }
});


export const MessageCreationView = Mn.LayoutView.extend({
  template: require('messaging/templates/layout.html'),
  tagName: 'form',

  attributes: {
    method: 'POST',
    action: ''
  },

  initialize() {
    this.joinos = false;
    this.sms = true;
  },

  ui: {
    checkSms: '.compose-sms',
    checkJoinos: '.compose-joinos',
    smsRegion: '.sms-hook',
    joinosRegion: '.joinos-hook'
  },

  events: {
    submit: 'send'
  },
  
  send(ev) {
    ev.preventDefault();
    this.trigger('saving');
    const view = new MessageSendingView({
      model: this.model
    });
    DialogService.show(view);

    this.model.save();
  },

  regions: {
    contact: '.contact-hook',
    sms: '.sms-hook',
    joinos: '.joinos-hook'
  },

  onRender() {
    const configModel = this.getOption('config');
    const config = configModel.pick('has_joinos', 'has_sms', 'has_contacts');

    this.model.set({
      use_joinos: config.has_joinos,
      use_sms: config.has_sms
    });

    if(config.has_joinos) {
      this.showChildView('joinos', new JoinosComposeView({
        config: configModel,
        model: this.model.get('joinos')
      }));
    }

    if(config.has_sms) {
      this.showChildView('sms', new SmsComposeView({
        config: configModel,
        number: this.getOption('contact_count'),
        model: this.model.get('sms')
      }));
    }

    if (config.has_contacts) {
      const contacts = new ContactView({
        filter: this.model.get('contacts')
      });
      this.showChildView('contact', contacts);
    }
  },
  
  templateHelpers() {
    return this.getOption('config').pick('has_joinos', 'has_sms');
  }
});



// WEBPACK FOOTER //
// ./messaging/views/layout.js